export default __webpack_public_path__ + "static/media/natali-dotan.f1f8306c.png";